export const validateEmail = (email) => {
  email = email.trim();
  if (email.length === 0) {
    return "Esse campo é obrigatório";
  }
  let isValid = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  if (!isValid) {
    return "Por favor, insira um e-mail válido";
  }
  return "";
}

export const validatePhone = (phone) => {
  phone = phone.trim();
  if (phone.length === 0) {
    return "Esse campo é obrigatório";
  }

  const isValid = String(phone)
    .match(/^\s*(\d{2})(\d{5}|\d{4})(\d{4})\s*$/);

  if (!isValid) {
    return "Por favor, insira um telefone válido";
  }

  return '';
}

const PHONE_ERROR_TRANSLATIONS = {
  'country_code and phone_number are required.': 'Código do país e número de telefone são obrigatórios.',
  'Invalid phone number.': 'Número de telefone inválido.',
  'Invalid phone number for the given country.': 'Número de telefone inválido para o país selecionado.',
  'Phone number is required.': 'Número de telefone é obrigatório.',
  'This field is required.': 'Este campo é obrigatório.',
  'This field may not be blank.': 'Este campo não pode ficar em branco.',
  'This field may not be null.': 'Este campo não pode ser nulo.',
  'Ensure this field has no more than 15 characters.': 'Este campo deve ter no máximo 15 caracteres.',
  'Ensure this field has no more than 5 characters.': 'Código de país deve ter no máximo 5 caracteres.',
  'This value does not match the required pattern.': 'Código de país inválido (use o formato "+55").',
};

const translatePhoneMessage = (message) => {
  if (!message) return '';
  return PHONE_ERROR_TRANSLATIONS[message] || message;
};

const collectMessages = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  if (typeof value === 'string') return [value];
  return [];
};

const findErrorContainer = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  const candidates = [payload, payload.errors, payload.error];
  for (const candidate of candidates) {
    if (!candidate || typeof candidate !== 'object') continue;
    if (
      candidate.phone_number ||
      candidate.phone ||
      candidate.country_code ||
      (candidate.customer && typeof candidate.customer === 'object')
    ) {
      return candidate;
    }
  }
  return null;
};

export const extractPhoneBackendErrors = (payload) => {
  const container = findErrorContainer(payload);
  if (!container) return { phone: '', countryCode: '' };

  const sources = [container];
  if (container.customer && typeof container.customer === 'object') {
    sources.push(container.customer);
  }

  let phoneMessages = [];
  let countryMessages = [];

  for (const source of sources) {
    phoneMessages = phoneMessages
      .concat(collectMessages(source.phone_number))
      .concat(collectMessages(source.phone));
    countryMessages = countryMessages.concat(collectMessages(source.country_code));
  }

  const phone = phoneMessages.map(translatePhoneMessage).filter(Boolean).join(' ');
  const countryCode = countryMessages.map(translatePhoneMessage).filter(Boolean).join(' ');

  return { phone, countryCode };
};

export const extractPhoneBackendError = (payload) => {
  const { phone, countryCode } = extractPhoneBackendErrors(payload);
  return phone || countryCode || '';
};

export const validatePhoneForCountry = (phone, countryCode) => {
  const digits = (phone || '').replace(/\D/g, '');
  if (digits.length === 0) {
    return "Esse campo é obrigatório";
  }

  if (countryCode === '+55') {
    return validatePhone(digits);
  }

  if (digits.length < 4 || digits.length > 15) {
    return "Por favor, insira um telefone válido";
  }

  return '';
}

export const validateName = (text) => {
  text = text.trim()
  if (text.length === 0) {
    return "Esse campo é obrigatório"
  }
  let parts = text.split(" ")
  let validParts = 0
  for (let part of parts) {
    if (part.trim().length > 0) {
      validParts++
    }
  }
  if (validParts < 2) {
    return "Por favor, insira seu nome completo"
  }

  return ""
}

const isValidCPF = (digits) => {
  if (digits.length !== 11) return false;
  if (/^(\d)\1+$/.test(digits)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(digits[i], 10) * (10 - i);
  let rem = sum % 11;
  const d1 = rem < 2 ? 0 : 11 - rem;
  if (d1 !== parseInt(digits[9], 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(digits[i], 10) * (11 - i);
  rem = sum % 11;
  const d2 = rem < 2 ? 0 : 11 - rem;
  return d2 === parseInt(digits[10], 10);
};

const isValidCNPJ = (digits) => {
  if (digits.length !== 14) return false;
  if (/^(\d)\1+$/.test(digits)) return false;
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += parseInt(digits[i], 10) * w1[i];
  let rem = sum % 11;
  const d1 = rem < 2 ? 0 : 11 - rem;
  if (d1 !== parseInt(digits[12], 10)) return false;
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  sum = 0;
  for (let i = 0; i < 13; i++) sum += parseInt(digits[i], 10) * w2[i];
  rem = sum % 11;
  const d2 = rem < 2 ? 0 : 11 - rem;
  return d2 === parseInt(digits[13], 10);
};

export const validateTaxpayerID = (text) => {
  const digits = (text || '').replace(/\D/g, '').trim();
  if (digits.length === 11) {
    return isValidCPF(digits) ? '' : 'CPF inválido';
  }
  if (digits.length === 14) {
    return isValidCNPJ(digits) ? '' : 'CNPJ inválido';
  }
  return 'Deve ser um CPF ou CNPJ válido';
}

export const validateCEP = (cep) => {
  if (/^\d{8}$/.test(cep)) {
    return '';
  } else {
    return "O CEP deve conter exatamente 8 dígitos numéricos";
  }
};

export const validateCardNumber = (number) => {
  number = number.replace(/\s/g, '').trim()
  if (number.length === 0) {
    return "Esse campo é obrigatório"
  }
  let isValid = String(number)
    .toLowerCase()
    .match(
      /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
    );
  if (!isValid) {
    return "Por favor, insira um número de cartão válido"
  }
  return ""
}